import { render, staticRenderFns } from "./PricingPlanItems.vue?vue&type=template&id=b2bebba2&scoped=true&"
import script from "./PricingPlanItems.vue?vue&type=script&lang=js&"
export * from "./PricingPlanItems.vue?vue&type=script&lang=js&"
import style0 from "./PricingPlanItems.vue?vue&type=style&index=0&id=b2bebba2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bebba2",
  null
  
)

export default component.exports